export default __webpack_public_path__ + "static/media/rawdata.4a40c3da.txt";